<template>
  <div class="upload-image">
    <div v-if="label" class="upload-image__label">
      {{ label }}
      <span v-if="required" class="upload-image__required">*</span>
    </div>

    <a-upload class="upload-image__upload" list-type="picture-card" :accept="accept" :multiple="false"
      :disabled="disabled" :file-list="fileList" :before-upload="beforeUpload" :remove="handleRemove" :show-upload-list="{
        showPreviewIcon: true,
        showRemoveIcon: !disabled
      }" @preview="handlePreview">
      <div v-if="fileList.length === 0" class="upload-image__placeholder">
        <img v-if="placeholderImage" :src="placeholderImage" alt="Hình ảnh hướng dẫn"
          class="upload-image__placeholder-image" />

        <div class="upload-image__placeholder-plus">
          <a-icon type="plus" />
        </div>

        <div class="upload-image__placeholder-bottom">
          <!-- <div class="upload-image__placeholder-title">
            {{ buttonText }}
          </div> -->

          <div class="upload-image__placeholder-note">
            JPG, PNG hoặc WEBP. Tối đa {{ maxSizeMb }} MB
          </div>
        </div>
      </div>
    </a-upload>

    <div v-if="showFileName && currentFileName" class="upload-image__file-name" :title="currentFileName">
      {{ currentFileName }}
    </div>
    <div v-if="fileList.length > 0" class="upload-image__actions">
      <a-upload :accept="accept" :multiple="false" :disabled="disabled" :show-upload-list="false"
        :before-upload="beforeUpload">
        <a-button size="small" icon="reload" :disabled="disabled">
          Chọn lại
        </a-button>
      </a-upload>

      <a-button size="small" type="danger" ghost icon="delete" :disabled="disabled" @click.stop.prevent="removeImage">
        Xóa ảnh
      </a-button>
    </div>


    <div v-if="errorMessage" class="upload-image__error">
      {{ errorMessage }}
    </div>

    <a-modal :visible="previewVisible" :footer="null" centered :title="currentFileName || 'Xem hình ảnh'"
      @cancel="closePreview">
      <img v-if="previewImage" :src="previewImage" :alt="currentFileName || 'Hình ảnh xem trước'"
        class="upload-image__preview-image" />
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'UploadImage',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: {
      default: null
    },

    label: {
      type: String,
      default: ''
    },

    buttonText: {
      type: String,
      default: 'Chọn hình ảnh'
    },

    accept: {
      type: String,
      default: 'image/jpeg,image/png,image/webp'
    },
    placeholderImage: {
      type: String,
      default: ''
    },

    maxSizeMb: {
      type: Number,
      default: 8
    },

    required: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    showFileName: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      fileList: [],
      currentFile: null,
      objectUrl: '',
      errorMessage: '',
      previewVisible: false,
      previewImage: ''
    }
  },

  computed: {
    currentFileName() {
      const item = this.fileList[0]
      return item ? item.name || '' : ''
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(file) {
        if (file === this.currentFile) {
          return
        }

        if (this.isFile(file)) {
          this.setSelectedFile(file, false)
          return
        }

        if (!file) {
          this.clearLocalState(false)
        }
      }
    }
  },

  beforeDestroy() {
    this.revokeObjectUrl()
  },

  methods: {

    emitValue(file) {
      console.log('UploadImage-Emit-Input:', file)

      this.$emit('input', file)
      this.$emit('change', file)
      this.$emit('update:value', file)
    },

    isFile(value) {
      return (
        typeof File !== 'undefined' &&
        value instanceof File
      )
    },

    beforeUpload(uploadFile) {
      const file =
        uploadFile && uploadFile.originFileObj
          ? uploadFile.originFileObj
          : uploadFile

      const result = this.validateFile(file)

      console.log('UploadImage-BeforeUpload:', {
        State: result.State,
        Message: result.Message,
        Data: file
          ? {
            Name: file.name,
            Type: file.type,
            Size: file.size
          }
          : null
      })

      if (!result.State) {
        this.errorMessage = result.Message

        if (this.$message) {
          this.$message.error(result.Message)
        }

        this.$emit('error', result)
        return false
      }

      this.errorMessage = ''
      this.setSelectedFile(file, true)

      return false
    },

    validateFile(file) {
      if (!file) {
        return {
          State: 0,
          Message: 'Không tìm thấy hình ảnh đã chọn.',
          Data: null
        }
      }

      const allowedMimeTypes = [
        'image/jpeg',
        'image/png',
        'image/webp'
      ]

      const fileName = String(file.name || '').toLowerCase()
      const fileType = String(file.type || '').toLowerCase()

      const validMime = allowedMimeTypes.includes(fileType)

      const validExtension =
        fileName.endsWith('.jpg') ||
        fileName.endsWith('.jpeg') ||
        fileName.endsWith('.png') ||
        fileName.endsWith('.webp')

      if (!validMime && !validExtension) {
        return {
          State: 0,
          Message: 'Chỉ chấp nhận ảnh JPG, PNG hoặc WEBP.',
          Data: null
        }
      }

      const maxBytes = this.maxSizeMb * 1024 * 1024

      if (file.size > maxBytes) {
        return {
          State: 0,
          Message: `Dung lượng ảnh không được vượt quá ${this.maxSizeMb} MB.`,
          Data: null
        }
      }

      return {
        State: 1,
        Message: 'Hình ảnh hợp lệ.',
        Data: file
      }
    },

    setSelectedFile(file, emitValue) {
      this.revokeObjectUrl()

      this.currentFile = file
      this.objectUrl = URL.createObjectURL(file)

      this.fileList = [
        {
          uid: file.uid || `upload-image-${Date.now()}`,
          name: file.name || 'Hình ảnh',
          status: 'done',
          type: file.type,
          size: file.size,
          url: this.objectUrl,
          thumbUrl: this.objectUrl,
          originFileObj: file
        }
      ]

      if (emitValue) {
        this.emitValue(file)
      }
    },

    handlePreview(fileItem) {
      const image =
        fileItem.url ||
        fileItem.thumbUrl ||
        this.objectUrl

      if (!image) {
        return
      }

      this.previewImage = image
      this.previewVisible = true
    },

    closePreview() {
      this.previewVisible = false
    },

    handleRemove() {
      if (this.disabled) {
        return false
      }

      this.removeImage()
      return true
    },

    removeImage() {
      if (this.disabled) {
        return
      }

      this.clearLocalState(true)
    },

    clearLocalState(emitValue) {
      this.revokeObjectUrl()

      this.fileList = []
      this.currentFile = null
      this.errorMessage = ''
      this.previewVisible = false
      this.previewImage = ''

      if (emitValue) {
        this.emitValue(null)
        this.$emit('remove')
      }
    },

    revokeObjectUrl() {
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl)
        this.objectUrl = ''
      }
    }
  }
}
</script>

<style scoped>
.upload-image {
  width: 100%;
  font-family: Arial, Helvetica, sans-serif;
}

.upload-image__label {
  margin-bottom: 7px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5;
}

.upload-image__required {
  margin-left: 3px;
  color: #f5222d;
}

.upload-image__placeholder {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 180px;
  overflow: hidden;
  background: #fafafa;
}

.upload-image__placeholder-image {
  position: absolute;
  top: 8px;
  right: 8px;
  bottom: 54px;
  left: 8px;
  display: block;
  width: calc(100% - 16px);
  height: calc(100% - 62px);
  object-fit: contain;
  opacity: 0.78;
}

.upload-image__placeholder-plus {
  position: absolute;
  top: calc(50% - 18px);
  left: 50%;
  z-index: 2;
  display: flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  color: rgba(0, 0, 0, 0.72);
  font-size: 23px;
  opacity: 70%;
  transform: translate(-50%, -50%);
}

.upload-image__placeholder-bottom {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
  padding: 8px 10px;
  background: rgba(255, 255, 255, 0.94);
  text-align: center;
}

.upload-image__placeholder-title {
  color: rgba(0, 0, 0, 0.85);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
}

.upload-image__placeholder-note {
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 11px;
  font-style: italic;
  line-height: 1.35;
}

.upload-image__placeholder-icon {
  margin-bottom: 8px;
  font-size: 26px;
}

.upload-image__placeholder-title {
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
}

.upload-image__placeholder-note {
  margin-top: 5px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  line-height: 1.4;
}

.upload-image__actions {
  display: flex;
  margin-top: 8px;
  align-items: center;
  gap: 8px;
}

.upload-image__file-name {
  overflow: hidden;
  color: rgba(0, 0, 0, 0.65);
  font-size: 12px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-image__error {
  margin-top: 5px;
  color: #f5222d;
  font-size: 12px;
  line-height: 1.4;
}

.upload-image__preview-image {
  display: block;
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
}
</style>

<style>
.upload-image .ant-upload input[type='file'] {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  opacity: 0 !important;
}

.upload-image .ant-upload-list-picture-card-container,
.upload-image .ant-upload-list-picture-card .ant-upload-list-item,
.upload-image .ant-upload.ant-upload-select-picture-card {
  width: 100%;
  height: 180px;
  margin: 0;
}

.upload-image .ant-upload-list-picture-card {
  display: block;
}

.upload-image .ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
.upload-image .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.upload-image .ant-upload-list-picture-card .ant-upload-list-item-info::before {
  left: 0;
}

.upload-image .ant-upload-list-picture-card .ant-upload-list-item-actions a {
  width: 60px;
  height: 40px;
  line-height: 40px;
}

.upload-image .ant-upload-list-picture-card .ant-upload-list-item-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.upload-image .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon {
  font-size: 30px;
}
</style>
